import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { MatIconModule } from '@angular/material/icon';
import { NgIf } from '@angular/common';

import { NumberPipe } from '../../../shared/pipes/number.pipe';

interface IconHeaderParams extends IHeaderParams {
	value: number;
	iconName: string;
}

@Component({
	selector: 'copo-icon-header',
	templateUrl: './order-status-icon-header.component.html',
	styleUrl: './order-status-icon-header.component.css',
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgIf, MatIconModule, NumberPipe]
})
export class OrderStatusIconHeaderComponent implements IHeaderAngularComp {
	params?: IconHeaderParams;

	agInit(params: IconHeaderParams) {
		this.params = params;
	}

	refresh(params: IconHeaderParams) {
		this.agInit(params);
		return true;
	}
}
